<ngb-alert
  *ngIf="message"
  type="danger"
  class="alert text-white bg-danger border-0 app-errors"
  (closed)="closeErrorMsgDialog($event)"
>
  <span>{{message}}</span>
</ngb-alert>
